import React from 'react';

// template components
import RelatedLinks from '@nmx/template/dist/componentLibrary/layout/Footer/RelatedLinks';

export default () => {
  const linkItems = [
    {
      linkUrl: '/fixed-annuity-vs-variable-annuity/performance-history/',
      linkId: 'related-links-performance-history',
      linkText: 'Performance History',
      ariaLabel: 'Learn More About Performance History For a Specific Product',
      isOutgoingLink: true,
      children: '',
    },
  ];

  return (
    <RelatedLinks
      sectionId='related-links-daily-unit-values-page'
      linkItems={linkItems}
      moduleName='related-links'
      moduleVariation='A'
      backgroundVariant='lightA'
      themeType='lightTheme'
      disableBottomPadding />
  );
};